import React from 'react';
import { Routes, Route} from 'react-router-dom';
import KeepAlive,{AliveScope} from 'react-activation'
import Home from '@/pages/index.jsx';
import WishDetail from '@/pages/components/dialog/wishDetail/detail/index.jsx';
export const RouteList = (
  <AliveScope>
  <Routes>
    <Route path='/' element={
      <KeepAlive cacheKey="Home">
        <Home />
      </KeepAlive>
    } />
    <Route path='/wishDetail/:id' element={<WishDetail />} />
  </Routes>
  </AliveScope>
);
